import { render } from "./LoansUser.vue?vue&type=template&id=073d1be8"
import script from "./LoansUser.vue?vue&type=script&lang=js"
export * from "./LoansUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/redpoint-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__